// test1780
(1780 && 0);
